var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalkingUnauthorized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "639px",
    height: "897px",
    viewBox: "0 0 639 897",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "walking2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "walking2",
    transform: "translate(10.206279, 11.910959)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#3BB1E6",
    strokeWidth: 22,
    cx: 308.793721,
    cy: 373.089041,
    r: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 277.160749,
    y1: 218.146885,
    x2: 340.679478,
    y2: 218.146885,
    id: "Path-8",
    stroke: "#3BB1E6",
    strokeWidth: 24,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.160749,
    y1: 218.146885,
    x2: 493.679478,
    y2: 218.146885,
    id: "Path-8",
    stroke: "#3BB1E6",
    strokeWidth: 24,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.160749,
    y1: 218.146885,
    x2: 187.679478,
    y2: 218.146885,
    id: "Path-8",
    stroke: "#3BB1E6",
    strokeWidth: 24,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.1887833,
    y1: 265.445269,
    x2: 553.419553,
    y2: 265.445269,
    id: "Path-9",
    stroke: "#3BB1E6",
    strokeWidth: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 183.304168,
    y1: 572.329885,
    x2: 796.563325,
    y2: 572.340332,
    id: "Path-9",
    stroke: "#3BB1E6",
    strokeWidth: 22,
    transform: "translate(490.304168, 572.829885) rotate(90.000000) translate(-490.304168, -572.829885) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: -181.695832,
    y1: 572.329885,
    x2: 431.563325,
    y2: 572.340332,
    id: "Path-9",
    stroke: "#3BB1E6",
    strokeWidth: 22,
    transform: "translate(125.304168, 572.829885) rotate(90.000000) translate(-125.304168, -572.829885) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: -294.431507,
    y1: 523.340332,
    x2: 420.54855,
    y2: 520.340332,
    id: "Path-9",
    stroke: "#3BB1E6",
    strokeWidth: 24,
    transform: "translate(63.304168, 521.829885) rotate(90.000000) translate(-63.304168, -521.829885) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.568493,
    y1: 523.340332,
    x2: 911.54855,
    y2: 520.340332,
    id: "Path-9",
    stroke: "#3BB1E6",
    strokeWidth: 24,
    transform: "translate(554.304168, 521.829885) rotate(90.000000) translate(-554.304168, -521.829885) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3BB1E6",
    x: 64.793721,
    y: 415.089041,
    width: 59,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3BB1E6",
    x: 64.793721,
    y: 634.089041,
    width: 59,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3BB1E6",
    x: 494.793721,
    y: 415.089041,
    width: 59,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3BB1E6",
    x: 494.793721,
    y: 634.089041,
    width: 59,
    height: 23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.793720978,
    y1: 872.089041,
    x2: 617.793721,
    y2: 872.089041,
    id: "Path-10",
    stroke: "#3BB1E6",
    strokeWidth: 22,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.793721,
    y1: 872.089041,
    x2: 250.793721,
    y2: 541.179128,
    id: "Path-11",
    stroke: "#3BB1E6",
    strokeWidth: 24,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.793721,
    y1: 872.089041,
    x2: 366.793721,
    y2: 541.179128,
    id: "Path-11",
    stroke: "#3BB1E6",
    strokeWidth: 24,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.793721,
    y1: 872.089041,
    x2: 308.793721,
    y2: 634.089041,
    id: "Path-11",
    stroke: "#3BB1E6",
    strokeWidth: 25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.793721,
    y1: 166.09421,
    x2: 552.793721,
    y2: 166.09421,
    id: "Path-12",
    stroke: "#3BB1E6",
    strokeWidth: 24,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.180211,160.010694 C253.204299,117.792947 274.745618,96.6840726 307.804168,96.6840726 C357.391994,96.6840726 378.264276,154.852043 374.448951,164.09421",
    id: "Path-13",
    stroke: "#3BB1E6",
    strokeWidth: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.793721,
    y1: 0.0890412917,
    x2: 308.793721,
    y2: 62.0890413,
    id: "Path-14",
    stroke: "#3BB1E6",
    strokeWidth: 24,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.793721,
    y1: 47.0890413,
    x2: 204.793721,
    y2: 109.089041,
    id: "Path-14",
    stroke: "#3BB1E6",
    strokeWidth: 24,
    strokeLinecap: "round",
    transform: "translate(204.534774, 78.500000) rotate(-50.000000) translate(-204.534774, -78.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 412.793721,
    y1: 47.0890413,
    x2: 412.793721,
    y2: 109.089041,
    id: "Path-14",
    stroke: "#3BB1E6",
    strokeWidth: 24,
    strokeLinecap: "round",
    transform: "translate(412.534774, 78.500000) scale(1, -1) rotate(-50.000000) translate(-412.534774, -78.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.43008,451.920958 L393.34546,451.920958 C407.935585,455.195788 415.230648,464.606949 415.230648,480.154441 C415.230648,495.701934 415.230648,550.8468 415.230648,645.589041 C412.40889,659.806425 405.113827,666.915117 393.34546,666.915117 C381.577092,666.915117 372.726513,659.806425 366.793721,645.589041",
    id: "Path-15",
    stroke: "#3BB1E6",
    strokeWidth: 24,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.43008,451.920958 L248.34546,451.920958 C262.935585,455.195788 270.230648,464.606949 270.230648,480.154441 C270.230648,495.701934 270.230648,550.8468 270.230648,645.589041 C267.40889,659.806425 260.113827,666.915117 248.34546,666.915117 C236.577092,666.915117 227.726513,659.806425 221.793721,645.589041",
    id: "Path-15",
    stroke: "#3BB1E6",
    strokeWidth: 24,
    strokeLinecap: "round",
    transform: "translate(235.830364, 559.418037) scale(-1, 1) translate(-235.830364, -559.418037) "
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkingUnauthorized);
export default __webpack_public_path__ + "static/media/walking-unauthorized.867768d3c248d9f5d5e5fd9edde4501a.svg";
export { ForwardRef as ReactComponent };